import Proposal from '../interfaces/Proposal';
import { getConsigneeFieldRules } from './consigneeRules';

export const hasError = (currentStep: number): any => {
  if (currentStep === 1) {
    return {};
  } else if (currentStep === 2) {
    return {
      name: false,
      documentNumber: false,
      phoneNumber: false,
      cnpjConsigneeId: false,
      email: false,
      loanDetails: false,
      companyDocument: false,
      companyLegalName: false,
    };
  } else if (currentStep === 3) {
    return {};
  } else if (currentStep === 4) {
    return {};
  }
};

export const hasFilled = (currentStep: number, data: Proposal): any => {
  const { showEmailForInvoice: emailRequired, showExtraFields: extraFieldsRequired } = getConsigneeFieldRules(
    data.cnpjConsigneeId,
  );

  if (currentStep === 1) {
    return {};
  } else if (currentStep === 2) {
    return (
      data.name == null ||
      data.documentNumber == null ||
      !data.phoneNumber ||
      data.cnpjConsigneeId == null ||
      data.cnpjConsigneeId == '' ||
      (emailRequired && (!data.email || data.email.trim() === '')) ||
      (extraFieldsRequired && (!data.companyDocument || data.companyDocument.trim() === '')) ||
      (extraFieldsRequired && (!data.companyLegalName || data.companyLegalName.trim() === '')) ||
      data.loanDetails.length == 0
    );
  } else if (currentStep === 3) {
  } else if (currentStep === 4) {
    return {};
  }
};

export const validateCNPJ = (cnpj: string): string | null => {
  if (!cnpj) return 'CNPJ inválido. Verifique e tente novamente.';

  const cleanCnpj = cnpj.replace(/[^\d]+/g, '');

  if (cleanCnpj.length !== 14) {
    return 'CNPJ inválido. Verifique e tente novamente.';
  }

  if (/^(\d)\1+$/.test(cleanCnpj)) {
    return 'CNPJ inválido. Verifique e tente novamente.';
  }

  let length = cleanCnpj.length - 2;
  let numbers = cleanCnpj.substring(0, length);
  const digits = cleanCnpj.substring(length);
  let sum = 0;
  let pos = length - 7;
  for (let i = length; i >= 1; i--) {
    sum += +numbers.charAt(length - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== +digits.charAt(0)) {
    return 'CNPJ inválido. Verifique e tente novamente.';
  }

  length = length + 1;
  numbers = cleanCnpj.substring(0, length);
  sum = 0;
  pos = length - 7;
  for (let i = length; i >= 1; i--) {
    sum += +numbers.charAt(length - i) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== +digits.charAt(1)) {
    return 'CNPJ inválido. Verifique e tente novamente.';
  }

  return null;
};

export const validateCompanyLegalName = (value: string): string | null => {
  if (!value || value.trim().length < 2) {
    return 'Razão Social inválida. Informe um nome válido.';
  }

  const regex = /^[A-Za-zÀ-ÿ0-9\s&.,\-\/]+$/;

  if (!regex.test(value)) {
    return 'Razão Social inválida. Use apenas caracteres permitidos.';
  }

  return null;
};
